import React, { useState } from 'react';

const FilterBar = ({ jobOpenings, setFilteredJobs }) => {
  const [activeFilter, setActiveFilter] = useState('All');

  // Updated categories to reflect the two departments.
  const categories = ['All', 'Sales', 'Digital Marketing'];

  const handleFilterClick = (category) => {
    setActiveFilter(category);
    if (category === 'All') {
      setFilteredJobs(jobOpenings);
    } else {
      const filtered = jobOpenings.filter(job => {
        // Create a separate array for Digital Marketing skills
        const digitalMarketingSkills = ['SEO', 'SMO', 'PPC', 'Analytics', 'Team Lead'];
        
        // Filter logic based on the two new categories
        if (category === 'Sales') {
          return job.note && (job.note.includes('Sales Development') || job.note.includes('B2B Sales') || job.note.includes('B2C Sales'));
        }
        if (category === 'Digital Marketing') {
          // Check if any of the job's notes are in the digital marketing skills list
          return job.note && job.note.some(note => digitalMarketingSkills.includes(note));
        }
        return false; // Return false for any other case
      });
      setFilteredJobs(filtered);
    }
  };

  return (
    <div className="filter-bar">
      {categories.map(category => (
        <button
          key={category}
          className={`filter-btn ${activeFilter === category ? 'active' : ''}`}
          onClick={() => handleFilterClick(category)}
        >
          {category}
        </button>
      ))}
    </div>
  );
};

export default FilterBar;